import React from 'react';
import { useTranslation } from 'react-i18next';
import { useGetReportTopProducts } from '../../hooks/reports/useGetReportTopProducts';
import TopEntitiesCard from './TopEntitiesCard';

const TopProducts = ({ filter, limit = 10 }) => {
    const { i18n } = useTranslation();
    const isArabic = (i18n.language || 'en').startsWith('ar');
    const { items, isLoading } = useGetReportTopProducts({
        from: filter.from,
        to: filter.to,
        limit,
    });

    return (
        <TopEntitiesCard
            title={isArabic ? 'أعلى المنتجات مبيعاً' : 'Top selling products'}
            items={items}
            isLoading={isLoading}
            color="primary"
        />
    );
};

export default TopProducts;
